<template>
    <div style="height: 100%;padding: 32px 0;">
      <div class="flex flex-col h100" v-if="articleList.length > 0">
        <div class="article-item" v-for="item in articleList" @click="goDetail(item)">
          <div>
            <img class="imgPic" :src="item.coverImg" alt="">
          </div>
          <div class="itemWrap">
            <div class="itemTitle ">
              {{ item.title }}
            </div>
            <!-- <div class="text-[14px] text-[#808080]">
              {{ item.releaseTime }}
            </div> -->
            <div class="itemContent ellipsis" v-html="item.content">
              
            </div>
          </div>
        </div>
      </div>
      <div class="itemFooter" v-if="articleList.length > 0">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="pageNum"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
      <div class="noData" v-if="articleList.length == 0">抱歉，未能为您找到相关的搜索结果</div>
    </div>
</template>
  
<script>
  import {
    getSearchData
  } from "../../http/api/api";

  export default {
    name: "search",
    data() {
      return {
        articleList: [],
        total: 0,
        pageNum: 1,
        pageSize: 10
      };
    },
    mounted(){
      this.getArticleList()
    },
    watch:{
      "$route.query.val":{
        handler (val) {
          this.pageNum = 1
          this.getArticleList()
        },
        immediate: true
      }
    },
    methods:{
      async getArticleList(){
        const res = await getSearchData({
          title: this.$route.query.val || "",
          // companyCode: window.location.host,
          companyCode:window.location.host,
          page: this.pageNum,
          pageSize:this.pageSize
        })
        if(res.code === 200){
          this.articleList = res.data.list
          this.total = res.data.total
        }
      },
      sizeChange(val){
        this.pageSize = val
        this.getArticleList()
      },
      currentChange(val){
        this.pageNum = val
        this.getArticleList()
      },
      goDetail(item){
        this.$router.push({
          path: "/announcementDetails",
          query: { id: item.id },
        });
      }
    }
  }
</script>
  
<style scoped lang="scss">
  $primary-color:  #75AAFF;
  .ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  ::v-deep .el-pagination.is-background .el-pager li.is-active {
    background-color:  $primary-color; // 进行修改选中项背景和字体
  }
  ::v-deep .el-pager li:hover {
    color:  $primary-color;
  }
  .flex{
    display: flex;
  }
  .flex-col{
    flex-direction: column;
  }
  .h100{
    height: 100%;
  }
  .article-item{
    // flex  h-[200px] article-item py-[16px] box-border
    display: flex;
    height: 200px;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #D3D3D3;
    transition: all .5s;
  }
  .article-item:hover{
    background: #eee;
    cursor: pointer;
    border-bottom: 4px solid $primary-color;
    transform: scale(1.03)
  }
  .imgPic{
  //    w-[300px] h-[168px]
     width: 300px;
    height:168px;
  }
  .itemWrap{
    // flex flex-col ml-[16px] flex-1
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    flex: 1;
  }
  .itemTitle{
    // text-[18px] mt-[12px] font-bold text-[#333] cursor-pointer
    font-size: 18px;
    margin-top: 12px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
  }
  .itemContent{
    // mt-[16px] text-[#A9A9A9] w-[100%] ellipsis text-[12px]
    margin-top: 16px;
    color: #A9A9A9;
    width: 100%;
    font-size: 12px;
  }
  .itemFooter{
    //  flex justify-center mt-[20px]
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .noData{
    // text-center mt-[100px]
    text-align: center;
    margin-top: 100px;
  }
</style>